import store from '../../../store'
import  catalog_reviews from './catalog_reviews.vue'

window.REVIEWS=  new Vue({
    store,
    el: '#reviews_block',

    data () {
        return {

        }
    },
    created () {

    },
    components : {
        catalog_reviews
    }
});
